import React, { useState } from 'react';
import CommonCard from '../../../global/card';
import CommonSkeletonLoader from '../../../global/loading';
import { useGenericQuery } from '../../../../queries/use-generic-query';
import { QUERY_KEYS } from '../../../../lib/query-constants';
import SOURCES from '../../../../utils/constants';
import EnhancedAlertList from './enhancedAlertList';
import EnhancedAddAlert from './enhancedAddAlert';

const EnhancedAlerts = () => {
    const { DEFAULT_RECORDS_LISTING } = SOURCES;

    const [alertsViewType, setAlertsViewType] = useState(() => {
        return localStorage.getItem("alertsViewType") || "GRID";
    });

    const [sort, setSort] = useState({ sortType: "", sortOrder: 1 });
    const [editAlert, setEditAlert] = useState({ show: false, id: null });

    // Assuming alerts API doesn't use standard pagination or we start with defaults
    const keyParams = {
        sortBy: sort.sortType,
        sortOrder: sort.sortOrder
    };

    const { data: alerts, isLoading, isFetching } = useGenericQuery({
        endpoint: "alert",
        queryKey: QUERY_KEYS.alerts.lists(keyParams),
        queryParams: keyParams,
    });

    return (
        <CommonCard
            isListGridView={{
                show: true,
                viewType: alertsViewType,
                setViewType: setAlertsViewType,
                viewFor: "alertsViewType"
            }}
            isLoading={{
                show: isLoading,
                loaderCmp: <CommonSkeletonLoader rows={5} type="table" />
            }}
            isCreateButton={{
                show: true,
                text: "New Alert",
                onclick: () => setEditAlert({ show: true, id: null }),
            }}
            className={(!isLoading && isFetching) ? "opacity-50" : ""}
        >
            <EnhancedAlertList
                alerts={alerts}
                isLoading={isLoading}
                sort={sort}
                setSort={setSort}
                viewType={alertsViewType}
                setEditAlert={setEditAlert}
                keyParams={keyParams}
            />

            {editAlert.show && (
                <EnhancedAddAlert
                    showForm={editAlert.show}
                    setShowForm={(val) => setEditAlert(prev => ({ ...prev, show: val }))}
                    editAlert={editAlert}
                    keyParams={keyParams}
                />
            )}
        </CommonCard>
    );
};

export default EnhancedAlerts;